/**
 * Visual indicator shown when voice mode is active.
 *
 * Displays a pulsing mic icon and the current voice state.
 */

import React from 'react';
import { Mic } from 'lucide-react';
import { useVoiceOptional } from '../../context/VoiceContext';

export function VoiceOverlay() {
  const voice = useVoiceOptional();

  if (!voice || voice.voiceState !== 'active') return null;

  return (
    <div
      className="flex items-center gap-2 rounded-full bg-red-50 px-3 py-1.5 text-sm text-red-600 border border-red-200"
      data-testid="voice-overlay"
    >
      <div className="relative">
        <Mic className="w-4 h-4" />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full animate-pulse" />
      </div>
      <span className="font-medium">Voice active</span>
    </div>
  );
}
